import { useTranslation } from "react-i18next";

export function IosAudioRoutingHint() {
    const { t } = useTranslation();

    return <p className="text-sm text-muted-foreground">{t("ios_audio_routing_hint")}</p>;
}
